import { IVISAxios } from "../../Modules/Axios/IVISAxios";
import axios from "axios";

export const uploadFileByPresignedUrl = async (file, key) => {
  const { url } = await getPresignedUrlAndKey({
    key,
    contentType: file.type,
  });
  if (!url) {
    alert("서버 접속에 실패했습니다. 다시 시도해 주세요.");
    return;
  }
  const isUploadedOnBucket = await uploadToBucketByPresignedUrl(url, file);
  return isUploadedOnBucket;
};

const getPresignedUrlAndKey = async ({ key, contentType }) => {
  try {
    const response = await IVISAxios.post("/s3/presigned-url", {
      key,
      contentType,
    });
    if (response.status !== 200) throw new Error(response.data.message);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

const uploadToBucketByPresignedUrl = async (url, file) => {
  try {
    const response = await axios.put(url, file);

    return response.status === 200;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
};
